import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-963e3dfc"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]

import { computed, PropType } from 'vue'
import { storeToRefs } from 'pinia'
import { useMainStore, useSlidesStore } from '@/store'
import { ImageElementClip, PPTImageElement } from '@/types/slides'
import { ImageClipedEmitData } from '@/types/edit'
import { ContextmenuItem } from '@/components/Contextmenu/types'
import useElementShadow from '@/views/components/element/hooks/useElementShadow'
import useElementFlip from '@/views/components/element/hooks/useElementFlip'
import useHistorySnapshot from '@/hooks/useHistorySnapshot'
import useClipImage from './useClipImage'
import useFilter from './useFilter'

import ImageOutline from './ImageOutline/index.vue'
import ImageClipHandler from './ImageClipHandler.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
  elementInfo: {
    type: Object as PropType<PPTImageElement>,
    required: true,
  },
  selectElement: {
    type: Function as PropType<(e: MouseEvent | TouchEvent, element: PPTImageElement, canMove?: boolean) => void>,
    required: true,
  },
  contextmenus: {
    type: Function as PropType<() => ContextmenuItem[] | null>,
  },
},
  setup(__props) {

const props = __props



const mainStore = useMainStore()
const slidesStore = useSlidesStore()
const { clipingImageElementId } = storeToRefs(mainStore)

const isCliping = computed(() => clipingImageElementId.value === props.elementInfo.id)

const { addHistorySnapshot } = useHistorySnapshot()

const shadow = computed(() => props.elementInfo.shadow)
const { shadowStyle } = useElementShadow(shadow)

const flipH = computed(() => props.elementInfo.flipH)
const flipV = computed(() => props.elementInfo.flipV)
const { flipStyle } = useElementFlip(flipH, flipV)

const clip = computed(() => props.elementInfo.clip)
const { clipShape, imgPosition } = useClipImage(clip)

const filters = computed(() => props.elementInfo.filters)
const { filter } = useFilter(filters)

const handleSelectElement = (e: MouseEvent | TouchEvent) => {
  if (props.elementInfo.lock) return
  e.stopPropagation()
  props.selectElement(e, props.elementInfo)
}

const handleClip = (data: ImageClipedEmitData | null) => {
  mainStore.setClipingImageElementId('')
  
  if (!data) return

  const { range, position } = data
  const originClip: ImageElementClip = props.elementInfo.clip || { shape: 'rect', range: [[0, 0], [100, 100]] }

  const left = props.elementInfo.left + position.left
  const top = props.elementInfo.top + position.top
  const width = props.elementInfo.width + position.width
  const height = props.elementInfo.height + position.height

  let centerOffsetX = 0
  let centerOffsetY = 0

  if (props.elementInfo.rotate) {
    const centerX = (left + width / 2) - (props.elementInfo.left + props.elementInfo.width / 2)
    const centerY = -((top + height / 2) - (props.elementInfo.top + props.elementInfo.height / 2))

    const radian = -props.elementInfo.rotate * Math.PI / 180

    const rotatedCenterX = centerX * Math.cos(radian) - centerY * Math.sin(radian)
    const rotatedCenterY = centerX * Math.sin(radian) + centerY * Math.cos(radian)

    centerOffsetX = rotatedCenterX - centerX
    centerOffsetY = -(rotatedCenterY - centerY)
  }

  const _props = {
    clip: { ...originClip, range },
    left: left + centerOffsetX,
    top: top + centerOffsetY,
    width,
    height,
  }
  slidesStore.updateElement({ id: props.elementInfo.id, props: _props })
  
  addHistorySnapshot()
}

return (_ctx: any,_cache: any) => {
  const _directive_contextmenu = _resolveDirective("contextmenu")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["editable-element-image", { 'lock': __props.elementInfo.lock }]),
    style: _normalizeStyle({
      top: __props.elementInfo.top + 'px',
      left: __props.elementInfo.left + 'px',
      width: __props.elementInfo.width + 'px',
      height: __props.elementInfo.height + 'px',
    })
  }, [
    _createElementVNode("div", {
      class: "rotate-wrapper",
      style: _normalizeStyle({ transform: `rotate(${__props.elementInfo.rotate}deg)` })
    }, [
      (_unref(isCliping))
        ? (_openBlock(), _createBlock(ImageClipHandler, {
            key: 0,
            src: __props.elementInfo.src,
            clipData: __props.elementInfo.clip,
            width: __props.elementInfo.width,
            height: __props.elementInfo.height,
            top: __props.elementInfo.top,
            left: __props.elementInfo.left,
            rotate: __props.elementInfo.rotate,
            clipPath: _unref(clipShape).style,
            onClip: _cache[0] || (_cache[0] = range => handleClip(range))
          }, null, 8, ["src", "clipData", "width", "height", "top", "left", "rotate", "clipPath"]))
        : _withDirectives((_openBlock(), _createElementBlock("div", {
            key: 1,
            class: "element-content",
            style: _normalizeStyle({
          filter: _unref(shadowStyle) ? `drop-shadow(${_unref(shadowStyle)})` : '',
          transform: _unref(flipStyle),
        }),
            onMousedown: _cache[2] || (_cache[2] = $event => handleSelectElement($event)),
            onTouchstart: _cache[3] || (_cache[3] = $event => handleSelectElement($event))
          }, [
            _createVNode(ImageOutline, { elementInfo: __props.elementInfo }, null, 8, ["elementInfo"]),
            _createElementVNode("div", {
              class: "image-content",
              style: _normalizeStyle({ clipPath: _unref(clipShape).style })
            }, [
              _createElementVNode("img", {
                src: __props.elementInfo.src,
                draggable: false,
                style: _normalizeStyle({
              top: _unref(imgPosition).top,
              left: _unref(imgPosition).left,
              width: _unref(imgPosition).width,
              height: _unref(imgPosition).height,
              filter: _unref(filter),
            }),
                onDragstart: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["prevent"])),
                alt: ""
              }, null, 44, _hoisted_1),
              (__props.elementInfo.colorMask)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "color-mask",
                    style: _normalizeStyle({
              backgroundColor: __props.elementInfo.colorMask.color,
              opacity: __props.elementInfo.colorMask.opacity,
            })
                  }, null, 4))
                : _createCommentVNode("", true)
            ], 4)
          ], 36)), [
            [_directive_contextmenu, __props.contextmenus]
          ])
    ], 4)
  ], 6))
}
}

})